import SlideshowUploadAccessModal, {
  SLIDESHOW_UPLOAD_ACCESS_MODAL,
} from './modal';

export { SLIDESHOW_UPLOAD_ACCESS_MODAL };

export default SlideshowUploadAccessModal;
